import { CartLinesUpdateEvent } from '@shopify/events';

// Delegate so the form also works after a section reload in the theme editor.
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.plp__form')) return;
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return; // Keep the native cart-page fallback.
  event.preventDefault();
  if (form.dataset.submitting === 'true') return;
  form.dataset.submitting = 'true';
  const button = form.querySelector('[type="submit"]');
  const error = form.querySelector('[data-plp-cart-error]');
  const messages = {
    fr: 'Impossible de mettre à jour le panier. Vérifiez son contenu avant de réessayer.',
    de: 'Der Warenkorb konnte nicht aktualisiert werden. Bitte prüfen Sie ihn vor einem erneuten Versuch.',
    sv: 'Kundvagnen kunde inte uppdateras. Kontrollera innehållet innan du försöker igen.'
  };
  if (error) error.hidden = true;
  if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
  try {
    const data = new FormData(form);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))];
    data.set('sections', sections.join(','));
    data.set('sections_url', location.pathname);
    data.delete('return_to');
    const response = await fetch(form.action.replace(/\/add(?:\.js)?$/, '/add.js'), {
      method: 'POST', body: data, headers: { Accept: 'application/json' }
    });
    const added = await response.json();
    if (!response.ok || added.status) throw new Error(added.description || added.message);
    const root = window.Shopify?.routes?.root || '/';
    const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error();
    const cart = await cartResponse.json();
    form.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: String(data.get('id')), quantity: Number(data.get('quantity')) || 1 }],
      promise: Promise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'product-form-component', sourceId: form.id,
          itemCount: Number(data.get('quantity')) || 1, sections: added.sections, didError: false }
      })
    }));
    await customElements.whenDefined('theme-drawer');
    drawer.open();
  } catch (exception) {
    if (error) {
      error.textContent = exception.message || messages[document.documentElement.lang.split('-')[0]] || messages.fr;
      error.hidden = false;
    }
  } finally {
    delete form.dataset.submitting;
    if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
  }
});
